import { transparentize } from "polished";
import styled, { DefaultTheme } from "styled-components";

import { getDisabledStyle } from "../../../global.style";
import { CheckIcon } from "../../icon";
import { AuditTrailFieldType } from "../../smart/FieldInfo";

interface ISelected {
    $focused?: boolean;
    selected?: boolean;
}

const COLOR_PICKER_WIDTH = 23;
export const MAX_COLORS_IN_LINE = 6;

export const StyledMenu = styled.div`
    display: grid;
    padding: 10px;
    grid-template-columns: repeat(${MAX_COLORS_IN_LINE}, ${COLOR_PICKER_WIDTH}px);
    gap: 10px;
    z-index: 1;
    position: relative;
    background: ${props => props.theme.C_BG_popover};
`;

export const Circle = styled.div<ISelected>`
    width: ${COLOR_PICKER_WIDTH}px;
    height: ${COLOR_PICKER_WIDTH}px;
    border-radius: 50%;
    background: ${props => props.theme[props.color as keyof DefaultTheme] || props.color};
    position: relative;

    &:before {
        content: "";
        width: ${COLOR_PICKER_WIDTH + 4}px;
        height: ${COLOR_PICKER_WIDTH + 4}px;
        border-radius: 50%;
        position: absolute;
        top: -2px;
        left: -2px;
        z-index: -1;
        display: ${props => props.selected || props.$focused ? "block" : "none"};
        background: ${props => props.selected ? props.theme.C_BG_selected_color 
            : transparentize(0.5, props.theme.C_ACT_hover_without_opacity)};
    }
       
    &:hover {
        cursor: pointer;
        &:before {
            display: block;
        }
    }   
    
    ${CheckIcon} {
        position: relative;
        left: 1px;
        opacity: 0.75;
    }
`;

export const StyledSelect = styled.div<{
    isDisabled: boolean;
    auditTrailType?: AuditTrailFieldType;
}>` 
    position: relative;
    width: 68px;
    height: 34px;
    border-radius: ${props => props.theme.borderLargeRadius};
    border: solid 1px ${props => props.theme.C_FIELD_line};
    background: ${props => props.theme.C_FIELD_fill};
    
    &:hover {
        cursor: pointer;
    } 
    
    &:hover:after,
    &:focus-within:after {
      content: '';
      position: absolute;
      width: 62px;
      height: 28px;
      border: 1px solid ${props => props.theme.C_ACT_main} ;
      left: 2px;
      top: 2px;
      border-radius: ${props => props.theme.borderLargeRadius};
      pointer-events: none;
    }
    
    ${props => (props.auditTrailType === AuditTrailFieldType.NoDifference || props.auditTrailType === AuditTrailFieldType.HoveredNoDifference) && {
        background: props.theme.C_AUDIT_TRAIL_NO_DIFF
    }}
            
    ${props => (props.auditTrailType === AuditTrailFieldType.HoveredNoDifference) && {
        opacity: props.theme.C_AUDIT_TRAIL_DIFF_VISIBLE_OPACITY
    }}
  
    border: ${props => (props.auditTrailType === AuditTrailFieldType.NoDifference || props.auditTrailType === AuditTrailFieldType.HoveredNoDifference) ?
    `1px solid ${props.theme.C_AUDIT_TRAIL_NO_DIFF}` : `1px solid ${props.theme.C_FIELD_line}`};    
    
    ${props => (props.auditTrailType === AuditTrailFieldType.Difference || props.auditTrailType === AuditTrailFieldType.HoveredDifference) && {
    border: `3px solid ${props.theme.C_AUDIT_TRAIL_DIFF}`}}
        
    ${props => props.auditTrailType === AuditTrailFieldType.NoDifference && `
        & svg {
            display: none !important
        }
    `}
    
     ${props => props.auditTrailType === AuditTrailFieldType.HoveredNoDifference && `
        & svg {
            opacity: ${props.theme.C_AUDIT_TRAIL_DIFF_VISIBLE_OPACITY}
        }
    `}    
        
    & > input {
        height: 0;
        border: none;
        padding: 0;
        margin: 0;
    }
    
    & > ${Circle} {
        position: absolute;
        width: 22px;
        height: 22px;
        top: ${props => (props.auditTrailType === AuditTrailFieldType.Difference || props.auditTrailType === AuditTrailFieldType.HoveredDifference) ? "3px" : "5px"};
        left: ${props => (props.auditTrailType === AuditTrailFieldType.Difference || props.auditTrailType === AuditTrailFieldType.HoveredDifference) ? "4px" : "6px"};
        margin: 0;
        opacity: ${props => (props.auditTrailType === AuditTrailFieldType.NoDifference ? 0 : 1)}
    }
    
    
    ${props => getDisabledStyle(props.isDisabled)};
`;